import JobMapGraphCardRateContent from './JobMapGraphCardRateContent';
export default JobMapGraphCardRateContent;
